import React from "react";
import { observer } from "mobx-react";

const FEATURES = [
  {
    icon: "work",
    title: "Search by title & role",
    description: "Find people by job title, department, or seniority. Use primary role only to focus on their main position."
  },
  {
    icon: "business",
    title: "Filter by company & industry",
    description: "Narrow by company size, industry, location, funding stage, and more to match your ideal customer profile."
  },
  {
    icon: "playlist_add",
    title: "Add to lists",
    description: "Save contacts to custom lists, organize by campaign or segment, and keep everything in one place."
  },
  {
    icon: "file_download",
    title: "Export & use in campaigns",
    description: "Export lists to CSV or use them directly in Salesgear campaigns and sequences."
  }
];

const NoFilterApplied = () => {
  return (
    <div className="noFilters listBuilderInitial">
      <div className="listBuilderInitialInner">
        <div className="listBuilderInitialHero">
          <h1 className="listBuilderInitialTitle">Build targeted prospect lists in minutes</h1>
          <p className="listBuilderInitialSub">
            Use the filters on the left to find people by role, company, location, and more.
            Then add them to lists or use them in your campaigns.
          </p>
          <div className="listBuilderInitialStats">
            <div className="listBuilderInitialStat">
              <span className="listBuilderInitialStatValue">800M+</span>
              <span className="listBuilderInitialStatLabel">Contacts</span>
            </div>
            <div className="listBuilderInitialStatDivider" />
            <div className="listBuilderInitialStat">
              <span className="listBuilderInitialStatValue">70M+</span>
              <span className="listBuilderInitialStatLabel">Companies</span>
            </div>
          </div>
        </div>
        <div className="listBuilderInitialFeatures">
          {FEATURES.map((f, i) => (
            <div key={i} className="listBuilderInitialCard">
              <div className="listBuilderInitialCardIcon">
                <span className="material-icons" aria-hidden>{f.icon}</span>
              </div>
              <h3 className="listBuilderInitialCardTitle">{f.title}</h3>
              <p className="listBuilderInitialCardDesc">{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export { NoFilterApplied };
export default observer(NoFilterApplied);
